(function () {
  var SHARED_IMAGE_COUNT = 5; // positions 1–5 are shared watch photos

  function filterGallery(variantId) {
    var product = window.tfxProduct;
    if (!product) return;

    var variant = product.variants.find(function (v) { return v.id == variantId; });
    if (!variant || !variant.featured_media) return;

    var featuredPosition = variant.featured_media.position; // 1-based

    // --- Main slides ---
    document.querySelectorAll('.product-main-slide').forEach(function (slide) {
      var img = slide.querySelector('img[data-index]');
      if (!img) return;
      var idx = parseInt(img.getAttribute('data-index'), 10);
      slide.style.display = (idx <= SHARED_IMAGE_COUNT || idx === featuredPosition) ? '' : 'none';
    });

    // --- Thumbnails ---
    document.querySelectorAll('.product__thumb-item').forEach(function (item) {
      var idx = parseInt(item.getAttribute('data-index'), 10); // 0-based
      var variantIdx = featuredPosition - 1; // convert to 0-based
      item.style.display = (idx < SHARED_IMAGE_COUNT || idx === variantIdx) ? '' : 'none';
    });

    // --- Reinitialise Flickity ---
    var slideshow = document.querySelector('[data-product-photos]');
    if (slideshow && window.Flickity) {
      var flkty = Flickity.data(slideshow);
      if (flkty) {
        flkty.reloadCells();
        flkty.resize();
        flkty.select(featuredPosition - 1, false, true);
      }
    }
  }

  function init() {
    var select = document.querySelector('select[name="id"]');
    if (!select) return;

    filterGallery(select.value); // run on page load

    select.addEventListener('change', function () {
      filterGallery(this.value);
    });

    // also cover swatch/button-style selectors via the theme's event
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) filterGallery(e.detail.variant.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 600); });
  } else {
    setTimeout(init, 600);
  }
})();